// extracted by mini-css-extract-plugin
export default {"list":"tU1Y3v","listDirectionColumn":"ZuJMBq","item":"fgXqvF","link":"LZLucc"};